<section [formGroup]="listPackageGroup">
  <div class="custom-search-tab">
    <app-auto-completesearch [searchdataInput]="searchdataInput" [searchoptionalParams]="searchoptionalParams" (returnData)="receivedData($event)" (clearSearch)="clearData()"></app-auto-completesearch>
  </div>
  <label class="basic-label listLabel">{{packageListLabel}}</label>
  <section class="packageList" [ngClass]="loadFormCheck ? 'custom-radio-block-valid':'custom-radio-block-invalid'">
    <mat-radio-group class="packageListRadioGroup" formControlName="packageSelectedControl" name="packageListData" [required]="fieldRequired">
      @for (list of searchFullData; track list) {
        <mat-radio-button class="packageRadioButton" id="{{list.Name}}" [checked]="list.Id == selectedValue" [value]="list.Id" (change)="radioChange($event)">{{list.Name}}</mat-radio-button>
      }
    </mat-radio-group>
    @if (searchFullData.length == 0) {
      <div class="noData">{{'common.noDataFound' | translate}}</div>
    }
  </section>
</section>
